import { ReactElement } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { form } from '../../api';
import { TutorAssignmentForm } from '../../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  TutorAssignmentForm,
  AxiosResultDefaultError
>();

export function useTutorAssignmentLoader() {
  return useFetch();
}

export const TutorAssignmentLoaderConsumer = FetchConsumer;

export default function TutorAssignmentLoader({ children }: BaseLoaderProps) {
  return (
    <FetchProvider request={form} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
